import React, { createContext, useContext } from 'react';
import PropTypes, { node } from 'prop-types';
import { gql, useQuery } from '@apollo/client';
import SwitchTestContext from '../../context/SwitchTestContext';
import Loader from '../Common/Loader/Loader';

export const SwitchTestContextSsr = createContext({ featureFlags: {} });

function SwitchTestProvider({ children, keysWithTypeAndDefaultValue }) {
  const {
    switches,
  } = useContext(SwitchTestContextSsr);

  const switchValues = keysWithTypeAndDefaultValue.reduce((acc, {
    name,
    key, switchType,
  }) => {
    const value = switches?.[key];
    const switchKey = switchType === 'LD' ? name : key;
    acc[switchKey] = value;
    return acc;
  }, {});

  return (
    <SwitchTestContext.Provider value={{ digitalData: switchValues }}>
      {children}
    </SwitchTestContext.Provider>
  );
}

SwitchTestProvider.propTypes = {
  children: node.isRequired,
  keysWithTypeAndDefaultValue: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
      type: PropTypes.string,
      switchType: PropTypes.string,
      defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    }),
  ).isRequired,
};

const generateSwitchesQuery = (switchList, switchName) => {
  const switchFields = switchList.map(({
    name, key, type, switchType, defaultValue,
  }) => `${key}: ${type}(switchKey: "${name}", switchType: ${switchType}, defaultValue: ${type === 'isOn' ? defaultValue : `"${defaultValue}"`})`);
  const queryString = `
      query ${switchName} {
        switches {
          ${switchFields.join('\n')}
        }
      }
    `;
  return gql`${queryString}`;
};
export function SwitchTestProviderSsr({ children, keysWithTypeAndDefaultValue, switchName }) {
  const SWICHTES_QUERY = generateSwitchesQuery(keysWithTypeAndDefaultValue, switchName);
  const {
    data: { switches } = { switches: {} }, loading,
  } = useQuery(SWICHTES_QUERY, {
    fetchPolicy: 'cache-first',
    context: { batch: true },
  });

  if (loading) {
    return (
      <section className="loader-area">
        <Loader variant="shimmer" contentRows={2} id="ocn-loader" />
      </section>
    );
  }
  return (
    <SwitchTestContextSsr.Provider value={{ switches }}>
      <SwitchTestProvider keysWithTypeAndDefaultValue={keysWithTypeAndDefaultValue}>
        {children}
      </SwitchTestProvider>
    </SwitchTestContextSsr.Provider>
  );
}

SwitchTestProviderSsr.defaultProps = {
  switchName: 'FetchSwitches',
};

SwitchTestProviderSsr.propTypes = {
  children: node.isRequired,
  switchName: PropTypes.string,
  keysWithTypeAndDefaultValue: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
      type: PropTypes.string,
      switchType: PropTypes.string,
      defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    }),
  ).isRequired,
};
